module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/baby-sitting/child-age3-a46509ddcc708dfd3d6a3205c01fad7d.svg";